// extracted by mini-css-extract-plugin
export default {"leftDetails":"LeftDetails_leftDetails__jooiL","leftDetailsRow":"LeftDetails_leftDetailsRow__IfLKC","leftDetailsBanner":"LeftDetails_leftDetailsBanner__dM8YI"};